import React, { useContext, useEffect, useState } from "react";
import { AppDataContext } from "@src/components/AppDataContext";
import { SparksFeatureSupportPage } from "../feature-support/SparksFeatureSupportPage";
import { SparksStripePricing } from "../pricing/SparksStripePricing";
import { ExternalSwitches } from "@src/utils/experiments/constants";
import { useStartExperiment } from "@src/utils/experiment";
import { useFeatureFlag } from "@src/utils/useFeatureFlag";

const FEATURE_FLAG_TIMEOUT_MS = 1000;
const PAYWALL_EXPERIMENT = ExternalSwitches.WEB_EXTERNAL_PAYWALL_SPARKS;

const SparksPaywallExperimentEnrollment = () => {
  useStartExperiment(PAYWALL_EXPERIMENT);
  return null;
};

export const SparksPaywallPage = () => {
  const { data } = useContext(AppDataContext);
  const paywallVariant = useFeatureFlag(PAYWALL_EXPERIMENT);
  const sessionReady = !data.loadingSession;
  const featureFlagsLoaded = !!data.featureFlagsLoaded;
  const [featureFlagsTimedOut, setFeatureFlagsTimedOut] = useState(false);

  useEffect(() => {
    if (!sessionReady || featureFlagsLoaded || featureFlagsTimedOut) return;

    const timeoutId = window.setTimeout(() => {
      setFeatureFlagsTimedOut(true);
    }, FEATURE_FLAG_TIMEOUT_MS);

    return () => window.clearTimeout(timeoutId);
  }, [sessionReady, featureFlagsLoaded, featureFlagsTimedOut]);

  const isResolvingVariant = !featureFlagsTimedOut && (!sessionReady || !featureFlagsLoaded);
  const isTestVariant = !featureFlagsTimedOut && featureFlagsLoaded && paywallVariant.actualValue === "test";

  if (isResolvingVariant) {
    return <main className="min-h-[60svh] w-full brand-sparks" aria-busy="true" />;
  }

  return (
    <>
      {featureFlagsLoaded && !featureFlagsTimedOut && <SparksPaywallExperimentEnrollment />}
      {isTestVariant ? <SparksStripePricing /> : <SparksFeatureSupportPage />}
    </>
  );
};
